/* tslint:disable */
import { Injectable } from '@angular/core';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { Observable as __Observable, throwError as __throwError, Observable, BehaviorSubject, of, EMPTY } from 'rxjs';
import { map as __map, filter as __filter, catchError as __catchError, tap, catchError, shareReplay, map, take } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/firestore';
import { MemberService } from './member.service';
import { Member } from '../models/member';
@Injectable({
  providedIn: 'root'
})

export class ChatService {

  private collectionName = 'chats';
  // public merchant$ : Observable<Merchant>;
  merchant$ = new BehaviorSubject<string>(null);
  //private id = this.fireAuth.auth.currentUser.uid;
  constructor(private firestore: AngularFirestore,
    private memberService: MemberService) {
  }
    
  chatByID(res_uid){
    return this.firestore.collection(this.collectionName, ref => ref
        .where('from_uid', '==', res_uid)
        // .where('order_id', '!=', null))
        .orderBy("created_at", "desc"))
        
        .snapshotChanges()
      .pipe(map(actions => {
        return actions.map(a => {
          const order = a.payload.doc.data() as any;
          order.id = a.payload.doc.id;
          return order;
        })
      }))
    }


        // .pipe(map(actions => {
        //     return actions.map(a => {
        //       const chat = a.payload.doc.data() as any;
        //       chat.id = a.payload.doc.id;
        //       if ((chat.order_id != null)) {
        //         this.orderService.orderById(chat.order_id).subscribe((ordRes : Order) => {
        //             if(ordRes){
        //                 this.merchantService.merchantById(ordRes.merchant_id).subscribe((merRes : Merchant)=> {
        //                 chat.merchant = merRes
        //                 })
        //             }
        //         })
        //     }    
        //       return chat
        //     });
        //   }));
        
  chatByLocation(filterKey){
    return this.firestore.collection(this.collectionName, ref => ref
      .where('location_id', 'in', filterKey)
      .orderBy("created_at", "desc")).snapshotChanges()
      .pipe(map(actions => {
      return actions.map(a => {
        const chat = a.payload.doc.data() as any;
        chat.id = a.payload.doc.id;
        if (chat.member_id != null) {
          this.memberService.memberById(chat.member_id).subscribe((memRes : Member) => {
              if(memRes){
                  chat.member = memRes
              }
          })
      }    
        return chat
      });
    }));
  }
  
}
